export default "__VITE_ASSET__10f6c6ff__$_#icon-star__"